// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__Orf5C","menu":"navbar_menu__OiM+G"};